// extracted by mini-css-extract-plugin
export default {"Slider":"qlo2cZhJ_a","Slider__input":"spaJl5jVDm","Slider__labels":"yEGYZugXls","Slider__bubble":"AuQzx3fx3G"};